import { MenuType } from '../config/Config';
import { ItemInterface } from '../models/ItemInterface';

export const REPORT_TYPES_ITEMS: ItemInterface[] = [
  {
    value: MenuType.IFRAME_VIEWER,
    label: 'Visor URL',
  },
  {
    value: MenuType.POWER_BI_REPORT,
    label: 'Visor de Power BI',
  },
  {
    value: MenuType.PDF_VIEWER,
    label: 'Visor de PDF',
  },
  {
    value: MenuType.OFFICE_VIEWER,
    label: 'Visor de Office',
  },
];
